export const componentName = 'Tip';
